import { useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import DocumentDetail from './DocumentDetail';
import useDocumentDetails from './hooks/useDocumentDetails';
import './UploadDocument.scss';
import backArrowIcon from 'src/Admin/img/arrow_back.svg';

function ViewDocument(props) {
  const { userSpecDoc } = useDocumentDetails(props);
  const pageInfo = useRef(null);
  const location = useLocation();
  console.log('props--@', props);
  console.log('location.state--@', location.state);
  useEffect(() => {
    setTimeout(() => {
      if (pageInfo && pageInfo.current) {
        pageInfo.current.focus();
      }
    }, 10);
  }, []);

  return (
    <div>
      <div
        className="sr-only"
        role="heading"
        aria-level={1}
        tabIndex={0}
        ref={pageInfo}
      >
        {' '}
        View Documents Page
      </div>
      <div className="d-flex align-items-center view-documents-border ml-2">
        <Link
          to={userSpecDoc ? '/admin/Messages-Documents' : '/admin/view-member'}
          state={
            userSpecDoc
              ? {
                  selectedTabDocument: true,
                }
              : {
                  documentDetailBackButton: true,
                  ...location.state,
                }
          }
          //search={props.search}
          className="redirect-arrow pt-3"
        >
          <img src={backArrowIcon} alt="logo" />
        </Link>
        <div className="ml-3">
          <h1 id="greetings-time" aria-hidden={true}>
            View <span className="content-header-bold">Document(s)</span>
          </h1>
        </div>
      </div>

      <DocumentDetail {...props} />
    </div>
  );
}

export default ViewDocument;
